import { createFileRoute } from "@tanstack/react-router";



export const Route = createFileRoute("/_protected/delivery/praises/")({
  head: () => ({
    meta: [{ title: "好评管理 · imiker CRM" }],
  })
});
